import initSdk from '@gnosis.pm/safe-apps-sdk';
import { v4 as uuidv4 } from 'uuid';
class SafeAppsSdkConnector {
    constructor() {
        this.txCallbacks = new Map();
        const onSafeInfo = (safeInfo) => {
            this.safeAppInfo = safeInfo;
        };
        const onTransactionConfirmation = (txConfirmation) => {
            const callback = this.txCallbacks.get(txConfirmation.requestId);
            if (callback) {
                this.txCallbacks.delete(txConfirmation.requestId);
                callback.confirm({ safeTxHash: txConfirmation.safeTxHash });
            }
        };
        const onTransactionRejection = (txRejection) => {
            const callback = this.txCallbacks.get(txRejection.requestId);
            if (callback) {
                this.txCallbacks.delete(txRejection.requestId);
                callback.reject(new Error('Transaction rejected'));
            }
        };
        this.appsSdk = initSdk();
        this.appsSdk.addListeners({
            onSafeInfo,
            onTransactionConfirmation,
            onTransactionRejection
        });
    }
    isSafeApp() {
        return !!this.safeAppInfo;
    }
    sendTransactions(transactions) {
        const requestId = uuidv4();
        return new Promise((confirm, reject) => {
            this.txCallbacks.set(requestId, { confirm, reject });
            this.appsSdk.sendTransactions(transactions, requestId);
        });
    }
}
export default SafeAppsSdkConnector;
//# sourceMappingURL=index.js.map